(function(){
  function qs(s,r){return (r||document).querySelector(s)}
  function qsa(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))}
  var nav=qs('[data-nfl-nav]');
  if(nav){
    var btns=qsa('[data-nfl-panel]',nav),panels=qsa('.nfl-mega',nav);
    function closeAll(){panels.forEach(function(p){p.classList.remove('is-open')});btns.forEach(function(b){b.setAttribute('aria-expanded','false')})}
    function open(b){closeAll();var p=qs('#'+b.getAttribute('data-nfl-panel'));if(p){p.classList.add('is-open');b.setAttribute('aria-expanded','true')}}
    btns.forEach(function(b){
      b.addEventListener('mouseenter',function(){open(b)});
      b.addEventListener('click',function(e){e.preventDefault();b.getAttribute('aria-expanded')==='true'?closeAll():open(b)});
    });
    qsa('[data-nfl-plain]',nav).forEach(function(a){a.addEventListener('mouseenter',closeAll)});
    nav.addEventListener('mouseleave',closeAll);
    document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeAll();closeDrawer()}});
  }
  var drawer=qs('[data-nfl-drawer]');
  function closeDrawer(){if(drawer){drawer.classList.remove('is-open');document.body.style.overflow=''}}
  qsa('[data-nfl-open]').forEach(function(b){b.addEventListener('click',function(){if(drawer){drawer.classList.add('is-open');document.body.style.overflow='hidden'}})});
  qsa('[data-nfl-close]').forEach(function(b){b.addEventListener('click',closeDrawer)});
  if(drawer)drawer.addEventListener('click',function(e){if(e.target===drawer)closeDrawer()});
  qsa('[data-nfl-acc]').forEach(function(b){b.addEventListener('click',function(){
    var t=qs('#'+b.getAttribute('data-nfl-acc'));if(!t)return;var o=t.classList.toggle('is-open');b.setAttribute('aria-expanded',o?'true':'false');
  })});
  function initBanners(){
    qsa('[data-nfl-banners]').forEach(function(sec){
      if(sec.__nflBn)return;
      var tr=qs('.nfl-bn-track',sec);if(!tr)return;var n=tr.children.length;if(n<2)return;
      sec.__nflBn=true;
      var cur=0,timer=null,paused=false;
      function show(i){
        if(i>=n)i=0;if(i<0)i=n-1;cur=i;
        tr.scrollTo({left:i*tr.clientWidth,behavior:'smooth'});
      }
      function start(){stop();timer=setInterval(function(){if(!paused&&!document.hidden)show(cur+1)},6000)}
      function stop(){if(timer){clearInterval(timer);timer=null}}
      qsa('[data-nfl-bn]',sec).forEach(function(b){b.addEventListener('click',function(){show(cur+parseInt(b.getAttribute('data-nfl-bn'),10));start()})});
      var st;tr.addEventListener('scroll',function(){clearTimeout(st);st=setTimeout(function(){var w=tr.clientWidth||1;cur=Math.round(tr.scrollLeft/w)},120)});
      sec.addEventListener('mouseenter',function(){paused=true});
      sec.addEventListener('mouseleave',function(){paused=false});
      sec.addEventListener('focusin',function(){paused=true});
      sec.addEventListener('focusout',function(){paused=false});
      start();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initBanners);else initBanners();
  window.addEventListener('load',initBanners);
})();

/* Product gallery: prev/next arrows and photo counter (arrow keys handled by theme Swiper) */
(function(){
  var chev='<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function setup(gallery){
    var viewer=gallery.querySelector('.product-gallery__viewer');
    if(!viewer||!viewer.swiper||viewer.querySelector('.nfl-gal-arrow'))return !!(viewer&&viewer.swiper);
    var sw=viewer.swiper;
    if(sw.slides.length<2)return true;
    var prev=document.createElement('button'),next=document.createElement('button'),count=document.createElement('span');
    prev.type=next.type='button';
    prev.className='nfl-gal-arrow nfl-gal-arrow--prev';next.className='nfl-gal-arrow nfl-gal-arrow--next';
    prev.setAttribute('aria-label','Previous photo');next.setAttribute('aria-label','Next photo');
    prev.innerHTML=next.innerHTML=chev;
    count.className='nfl-gal-count';count.setAttribute('aria-hidden','true');
    viewer.appendChild(prev);viewer.appendChild(next);viewer.appendChild(count);
    function stop(e){e.preventDefault();e.stopPropagation();}
    prev.addEventListener('click',function(e){stop(e);sw.slidePrev();});
    next.addEventListener('click',function(e){stop(e);sw.slideNext();});
    function update(){
      var n=sw.slides.length,i=sw.activeIndex;
      count.textContent=(i+1)+' / '+n;
      prev.disabled=i<=0;next.disabled=i>=n-1;
    }
    sw.on('slideChange',update);update();
    return true;
  }
  function scan(){
    var pending=false;
    Array.prototype.forEach.call(document.querySelectorAll('product-gallery'),function(g){if(!setup(g))pending=true;});
    return pending;
  }
  var tries=0;
  function boot(){ if(scan()&&tries++<40)setTimeout(boot,250); }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  new MutationObserver(function(m){for(var i=0;i<m.length;i++)if(m[i].addedNodes.length){tries=0;boot();break;}})
    .observe(document.body,{childList:true,subtree:true});
})();

/* Product zoom (PhotoSwipe): prev/next arrows and photo counter */
(function(){
  var chev='<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function key(code){document.dispatchEvent(new KeyboardEvent('keydown',{key:code===37?'ArrowLeft':'ArrowRight',keyCode:code,which:code,bubbles:true}));}
  function setup(p){
    if(p.querySelector('.nfl-zoom-arrow'))return;
    var prev=document.createElement('button'),next=document.createElement('button'),count=document.createElement('span');
    prev.type=next.type='button';
    prev.className='nfl-gal-arrow nfl-zoom-arrow nfl-gal-arrow--prev';next.className='nfl-gal-arrow nfl-zoom-arrow nfl-gal-arrow--next';
    prev.setAttribute('aria-label','Previous photo');next.setAttribute('aria-label','Next photo');
    prev.innerHTML=next.innerHTML=chev;
    count.className='nfl-gal-count nfl-zoom-count';count.setAttribute('aria-hidden','true');
    p.appendChild(prev);p.appendChild(next);p.appendChild(count);
    ['pointerdown','mousedown','touchstart'].forEach(function(t){
      [prev,next].forEach(function(b){b.addEventListener(t,function(e){e.stopPropagation()},{passive:true})});
    });
    prev.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();key(37);});
    next.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();key(39);});
    function update(){
      var t=p.querySelectorAll('.product-zoom--thumbnails .product-gallery--media-thumbnail'),n=t.length,i=0;
      for(var j=0;j<n;j++)if(t[j].querySelector('.thumbnail--active')){i=j;break;}
      var hide=n<2,txt=(i+1)+' / '+n;
      if(prev.hidden!==hide){prev.hidden=next.hidden=count.hidden=hide;}
      if(count.textContent!==txt)count.textContent=txt;
    }
    var zt=p.querySelector('.product-zoom--thumbnails')||p;
    new MutationObserver(update).observe(zt,{subtree:true,attributes:true,attributeFilter:['class'],childList:true});
    update();
  }
  function boot(){var p=document.querySelector('.pswp');if(p)setup(p);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  new MutationObserver(boot).observe(document.body,{childList:true});
})();

/* Cart: big financing button (opens Synchrony's official popup via syfMPP.mppFromAnyWhere) */
(function(){
  if(!document.body.classList.contains('template-cart'))return;
  function total(){
    var el=document.querySelector('.cart-total .cart-subtotal');if(!el)return 0;
    var m=(el.innerText||'').match(/\$\s*([\d,]+(?:\.\d{2})?)/g);if(!m)return 0;
    return parseFloat(m[m.length-1].replace(/[$,\s]/g,''))||0;
  }
  function setup(){
    var widget=document.querySelector('.cart-total #syf-unifi-widget');
    if(!widget||document.querySelector('.nfl-fin'))return !!widget;
    var btn=document.createElement('button');
    btn.type='button';btn.className='nfl-fin';btn.hidden=true;
    btn.innerHTML='<span class="nfl-fin__amt"><b data-nfl-fin-amt></b><small>/mo</small></span><span class="nfl-fin__sub">for 6 months with special financing</span>';
    var express=document.querySelector('.cart-total .additional-checkout-buttons'),co=document.querySelector('.cart-total .cart-checkout .button-primary');
    if(express)express.insertAdjacentElement('afterend',btn);else if(co)co.insertAdjacentElement('afterend',btn);else widget.parentNode.insertBefore(btn,widget);
    widget.classList.add('nfl-fin-src');
    var amtEl=btn.querySelector('[data-nfl-fin-amt]');
    function update(){
      var t=total(),host=widget.querySelector('#syf-promo');
      var offer=host&&host.offsetHeight>0;
      var hide=!(t>0&&offer),txt=t>0?'$'+Math.ceil(t/6).toLocaleString('en-US'):'';
      if(btn.hidden!==hide)btn.hidden=hide;
      if(amtEl.textContent!==txt){
        amtEl.textContent=txt;
        btn.setAttribute('aria-label',txt+' per month for 6 months with special financing. See financing details');
      }
    }
    btn.addEventListener('click',function(){
      var t=total();
      if(window.syfMPP&&syfMPP.mppFromAnyWhere){
        if(window.syfWidgetObject)syfWidgetObject.siteCode='SesMfaSh01';
        syfMPP.mppFromAnyWhere(t?t.toFixed(2):'');
      }else{location.href='/pages/financing';}
    });
    var iv=setInterval(function(){if(!document.body.contains(btn)){clearInterval(iv);return;}update();},1000);
    update();
    return true;
  }
  setup();
  setInterval(function(){if(!document.querySelector('.nfl-fin'))setup();},1000);
})();

/* Product page: big financing button below the buy buttons (opens Synchrony's official popup) */
(function(){
  if(!document.body.classList.contains('template-product'))return;
  function price(w){
    var pc=w&&w.querySelector('#product-content');if(!pc)return 0;
    var m=(pc.textContent||'').match(/[\d,]+(?:\.\d{2})?/);return m?parseFloat(m[0].replace(/,/g,''))||0:0;
  }
  function setup(){
    var widget=document.querySelector('.product-app #syf-unifi-widget, #syf-unifi-widget.product-widget, #syf-unifi-widget');
    var pay=document.querySelector('.product-form--atc .shopify-payment-button')||document.querySelector('.product-form--atc');
    if(!widget||!pay)return false;
    if(document.querySelector('.nfl-fin--pdp'))return true;
    var btn=document.createElement('button');
    btn.type='button';btn.className='nfl-fin nfl-fin--pdp';btn.hidden=true;
    btn.innerHTML='<span class="nfl-fin__amt"><b data-nfl-fin-amt></b><small>/mo</small></span><span class="nfl-fin__sub">for 6 months with special financing</span>';
    pay.insertAdjacentElement('afterend',btn);
    var block=widget.closest('.shopify-block')||widget;block.classList.add('nfl-fin-src');
    document.body.classList.add('nfl-has-fin');
    var amtEl=btn.querySelector('[data-nfl-fin-amt]');
    function update(){
      var t=price(widget),host=widget.querySelector('#syf-promo');
      var atc=document.querySelector('.product-form--atc-button'),sold=!!(atc&&atc.disabled);
      var hide=!(t>0&&host&&host.offsetHeight>0)||sold,txt=t>0?'$'+Math.ceil(t/6).toLocaleString('en-US'):'';
      if(btn.hidden!==hide)btn.hidden=hide;
      if(amtEl.textContent!==txt){amtEl.textContent=txt;btn.setAttribute('aria-label',txt+' per month for 6 months with special financing. See financing details');}
    }
    btn.addEventListener('click',function(){
      var t=price(widget);
      if(window.syfMPP&&syfMPP.mppFromAnyWhere){
        if(window.syfWidgetObject)syfWidgetObject.siteCode='SesMfaSh01';
        syfMPP.mppFromAnyWhere(t?t.toFixed(2):'');
      }else{location.href='/pages/financing';}
    });
    var iv=setInterval(function(){if(!document.body.contains(btn)){clearInterval(iv);return;}update();},1000);
    update();
    return true;
  }
  setup();
  setInterval(function(){if(!document.querySelector('.nfl-fin--pdp'))setup();},1000);
})();

/* Header: rotate approved Google reviews (from the google_review metaobject) */
(function(){
  var box=document.querySelector('[data-nfl-reviews]'),src=document.querySelector('[data-nfl-reviews-json]');
  if(!box||!src)return;
  var list;try{list=JSON.parse(src.textContent)}catch(e){return}
  if(!list||list.length<2)return;
  for(var i=list.length-1;i>0;i--){var j=Math.floor(Math.random()*(i+1)),t=list[i];list[i]=list[j];list[j]=t;}
  var text=box.querySelector('[data-nfl-review-text]'),idx=0,paused=false;
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  function esc(s){return String(s||'').replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}
  var starsEl=box.querySelector('[data-nfl-review-stars]');
  function render(r){
    var n=r.r||5;if(starsEl){starsEl.textContent='\u2605'.repeat(n)+'\u2606'.repeat(5-n);starsEl.setAttribute('aria-label',n+' out of 5 stars');}
    text.innerHTML='“'+esc(r.q)+'” <span class="nfl-q__by">— '+esc(r.by)+(r.store?', '+esc(r.store):'')+' · Google review</span>';
    text.title=r.q;
  }
  function next(){
    if(paused||document.hidden)return;
    idx=(idx+1)%list.length;
    if(reduce){render(list[idx]);return;}
    text.classList.add('is-out');
    setTimeout(function(){render(list[idx]);text.classList.remove('is-out');},600);
  }
  render(list[0]);
  box.addEventListener('mouseenter',function(){paused=true});
  box.addEventListener('mouseleave',function(){paused=false});
  setInterval(next,20000);
})();

/* Product page: one approved Google review under the buy buttons (static, random per page load) */
(function(){
  if(!document.body.classList.contains('template-product'))return;
  function setup(){
    var src=document.querySelector('[id^="nfl-rev-"] [data-list]');
    var anchor=document.querySelector('.nfl-fin--pdp:not([hidden])')||document.querySelector('.product-form--atc .shopify-payment-button')||document.querySelector('.product-form--atc');
    if(!src||!anchor)return false;
    if(document.querySelector('.nfl-pdp-review'))return true;
    var list;try{list=JSON.parse(src.textContent)}catch(e){return true}
    if(!list||!list.length)return true;
    var r=list[Math.floor(Math.random()*list.length)];
    var el=document.createElement('figure');el.className='nfl-pdp-review';
    var q=document.createElement('blockquote');q.textContent='“'+r.q+'”';
    var by=document.createElement('figcaption');by.textContent=r.by+(r.store?', '+r.store:'')+' · Google review';
    var st=document.createElement('span');st.className='nfl-pdp-review__stars';var sn=r.r||5;st.setAttribute('aria-label',sn+' out of 5 stars');st.textContent='\u2605'.repeat(sn)+'\u2606'.repeat(5-sn);
    el.appendChild(st);el.appendChild(q);el.appendChild(by);
    anchor.insertAdjacentElement('afterend',el);
    return true;
  }
  var n=0;(function boot(){if(!setup()&&n++<20)setTimeout(boot,300);})();
})();
